// Must load before Turbo, so a Back-button guard can run ahead of Turbo's own handler
import "../javascript/back_guard";
// JS and config file for FontAwesome
import "@fortawesome/fontawesome-free/js/all";
import { config } from "@fortawesome/fontawesome-svg-core";
// Turbo plus the cable stream-source element for live page updates
import "@hotwired/turbo-rails";
// Stimulus framework for easily adding javascript to the DOM
import { Application } from "@hotwired/stimulus";
// Helper for registering stimulus controllers with vite
import { registerControllers } from "stimulus-vite-helpers";
// Collection of functions using bootstrap initialized when DOM is ready
import "../javascript/bootstrap";
// Datadog logging configuration
import { initializeDatadog } from "../javascript/datadog";

/**
 * Font Awesome Configuration
 * */
config.autoAddCss = false; // Prevent FA from dynamically adding its css since we added it manually in application.scss
FontAwesome.config.mutateApproach = "sync"; // Ensures icon CSS is loaded immediately before attempting to render icons

/**
 * Stimulus Configuration
 * */
const stimulusApp = Application.start(); // Initialize Stimulus app
stimulusApp.debug = false; // Enable debugging mode
window.Stimulus = stimulusApp; // Bind Stimulus to the window object
// Import all the stimulus controllers
// TODO: Look into dynamic loading of controllers so their not all imported at once
const controllers = import.meta.glob("../javascript/controllers/**/*_controller.js", { eager: true });
const componentControllers = import.meta.glob("../../views/components/**/*_controller.js", { eager: true });

registerControllers(stimulusApp, { ...controllers, ...componentControllers }); // Register the found controllers with the Stimulus app

// Initialize Datadog browser logging
initializeDatadog();
